import { type MCPServerInfo } from '../../types';

const IterableServer: MCPServerInfo = {
  serverId: 'ITERABLE',
  name: 'Iterable',
  slug: 'iterable',
  description:
    "Iterable's official MCP server for managing campaigns, templates, and customer data. Runs in read-only mode by default — upstream gates write, send, and PII operations behind explicit env vars.",
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/Iterable/mcp-server',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@iterable/mcp'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['iterableApiKey'],
    properties: {
      iterableApiKey: {
        type: 'string',
        description:
          'Iterable API key. Create one under Integrations → API Keys in your Iterable workspace.',
        sensitive: true
      },
      iterableBaseUrl: {
        type: 'string',
        description:
          'Iterable API base URL. Default: https://api.iterable.com (US). EU customers use https://api.eu.iterable.com.',
        sensitive: false,
        default: 'https://api.iterable.com'
      }
    }
  }
};

export default IterableServer;
